<template>
  <div class="user-images-page">
    <div class="topbar">
      <TextBody i18n-key="account.userImages" tag="span" />
      <BbBtn size="x-small" type="icon" icon="x-small" icon-size="medium" no-background @click="goBackToAuthor" />
    </div>
    <div class="user-images-container">
      <ImagesList />
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';

import useModals from '~/composables/useModals';
import ImagesList from '~/components/userImages/ImagesList.vue';
import TextBody from '~/components/common/TextBody.vue';

export default {
  name: 'UserImages',
  components: {
    ImagesList,
    TextBody,
  },
  setup() {
    const router = useRouter();
    const { currentDocumentsDialog } = useModals();

    const goBackToAuthor = () => router.back();

    return {
      goBackToAuthor,
    };
  },
};
</script>

<style scoped lang="scss">
.user-images-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.topbar {
  padding: $bb-spacing-5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: $bb-neutral-0;
  border-bottom: 1px solid $bb-neutral-4;
  flex-shrink: 0;
}

.user-images-container {
  display: flex;
  flex-direction: row;
  min-height: 0;
  flex: 1;
  width: 100%;
}
</style>
